import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";

const baseUrl = "/api/term/spolVrsta";

/**
 * GET /api/term/spolVrsta/page
 */
export const fetchSpeciesGenderAgeTypeCodePage = createAsyncThunk(
  "speciesGenderAgeTypeCode/page",
  async ({ page, filter, sort } = {}, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        true // stripQueryParamsForCancelPrevious
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * GET /api/term/spolVrsta/{id}
 */
export const fetchSpeciesGenderAgeTypeCodeById = createAsyncThunk(
  "speciesGenderAgeTypeCode/id",
  async (id, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * POST /api/term/spolVrsta
 */
export const createGenderTypeCode = createAsyncThunk(
  "speciesGenderAgeTypeCode/create",
  async (payload, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.post(baseUrl, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * PUT /api/term/spolVrsta/{id}
 */
export const updateGenderTypeCode = createAsyncThunk(
  "speciesGenderAgeTypeCode/update",
  async ({ id, payload }, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.put(`${baseUrl}/${id}`, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * DELETE /api/term/spolVrsta/{id}
 */
export const deleteGenderTypeCode = createAsyncThunk(
  "speciesGenderAgeTypeCode/delete",
  async (id, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      await ApiClient.delete(`${baseUrl}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const genderTypeCodeListSlice = createSlice({
  name: "speciesGenderAgeTypeCode",
  initialState: {
    list: [],
    page: {},
    byId: {},
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    /* Page */
    builder
      .addCase(fetchSpeciesGenderAgeTypeCodePage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSpeciesGenderAgeTypeCodePage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchSpeciesGenderAgeTypeCodePage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    /* By ID */
    builder
      .addCase(fetchSpeciesGenderAgeTypeCodeById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSpeciesGenderAgeTypeCodeById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.byId[action.payload.id] = action.payload;
      })
      .addCase(fetchSpeciesGenderAgeTypeCodeById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
    /* CREATE */
    builder
      .addCase(createGenderTypeCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.byId[action.payload.output.id] = action.payload.output;
      })
      .addCase(createGenderTypeCode.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createGenderTypeCode.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      });

    /* UPDATE */
    builder
      .addCase(updateGenderTypeCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.byId[action.payload.output.id] = action.payload.output;
      })
      .addCase(updateGenderTypeCode.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateGenderTypeCode.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      });

    /* DELETE */
    builder
      .addCase(deleteGenderTypeCode.fulfilled, (state, action) => {
        state.isLoading = false;
        delete state.byId[action.payload.output];
      })
      .addCase(deleteGenderTypeCode.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(deleteGenderTypeCode.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export default genderTypeCodeListSlice.reducer;
